<template>
  <v-btn
    flat
    color="primary"
    class="history-download-action"
    :loading="loading"
    :disabled="disabled"
    :aria-label="accessibleLabel"
    :data-test="artifact.type === 'pdf' ? 'history-export-download-pdf' : 'history-export-download-jpeg'"
    @click="$emit('download', artifact)"
  >
    <v-icon left small>file_download</v-icon>
    {{ $t('license.history_export.download_format', { format: artifactFormat }) }}
  </v-btn>
</template>

<script>
export default {
  props: {
    artifact: { type: Object, required: true },
    examIndex: { type: Number, required: true },
    artifactIndex: { type: Number, required: true },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    artifactFormat() {
      return this.artifact.type === 'pdf' ? 'PDF' : 'JPEG'
    },
    accessibleLabel() {
      return this.$t('license.history_export.download_artifact', {
        format: this.artifactFormat,
        exam: this.examIndex,
        artifact: this.artifactIndex,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.history-download-action { min-height: 44px; margin: 0; }
@media (max-width: 600px) {
  .history-download-action { flex: 1 0 calc(100% - 52px); width: calc(100% - 52px); margin-left: 52px; }
}
</style>
